import { Injectable, inject } from '@angular/core';
import { distinctUntilChanged, filter } from 'rxjs/operators';
import { AuthService } from '../../core/services/auth.service';
import { ApiService } from '../../core/services/api.service';
import { I18nService } from './i18n.service';

@Injectable({ providedIn: 'root' })
export class LanguageSyncService {
  private readonly auth = inject(AuthService);
  private readonly api = inject(ApiService);
  private readonly i18n = inject(I18nService);

  private lastUserId: string | null = null;

  constructor() {
    this.auth.currentUser$
      .pipe(
        filter(user => !!user),
        distinctUntilChanged((a, b) => (a?.id ?? null) === (b?.id ?? null))
      )
      .subscribe(() => {
        this.refreshFromProfile();
      });
  }

  private refreshFromProfile(): void {
    this.api.get<unknown>('anggota-amh/profil').subscribe({
      next: (res) => {
        const typed = res as { data?: { anggota_amh?: { idu?: string; dasbor?: { bhs?: string | null } } } };
        const userId = typed?.data?.anggota_amh?.idu ? String(typed?.data?.anggota_amh?.idu) : null;
        const lang = typed?.data?.anggota_amh?.dasbor?.bhs;
        if (userId && userId === this.lastUserId && !lang) return;
        if (userId) this.lastUserId = userId;
        if (lang) this.i18n.setLanguage(lang, true);
      },
      error: () => {
      }
    });
  }
}
